import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BellRing, Download } from "lucide-react";

function downloadCsvFile(url, filename) {
  api.get(url, { responseType: "blob" }).then((res) => {
    const blob = new Blob([res.data], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
}

export default function AdminAlertsStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/alerts-stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;

  const totalOptin = s.opt_in_total;
  const rate = s.opt_in_rate;

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6" data-testid="admin-alerts-stats">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <BellRing size={20} className="text-[#E05638]"/>
          <div className="font-heading text-lg font-bold">Alertes bénéficiaires par pôle</div>
        </div>
        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={()=>downloadCsvFile("/admin/beneficiaries/export?only_optin=true", "beneficiaires-optin-tous.csv")}
            data-testid="alerts-export-all-btn"
            className="text-xs font-semibold text-[#E05638] hover:underline inline-flex items-center gap-1"
          >
            <Download size={14}/> Export global
          </button>
          <div className="text-right">
            <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Taux opt-in</div>
            <div className="font-heading text-2xl font-extrabold text-emerald-700">{rate}%</div>
            <div className="text-xs text-slate-500">{totalOptin} / {s.total_particulars} particuliers</div>
          </div>
        </div>
      </div>

      <div className="mt-5 space-y-3">
        {s.per_pole.map((p) => {
          const pct = p.total > 0 ? Math.round((p.opt_in / p.total) * 100) : 0;
          return (
            <div key={p.id} data-testid={`alerts-pole-${p.id}`} className="group">
              <div className="flex items-center justify-between text-sm">
                <div className="font-semibold text-slate-800 flex items-center gap-2">
                  {p.center}
                  {p.opt_in > 0 && (
                    <button
                      type="button"
                      onClick={()=>downloadCsvFile(`/admin/beneficiaries/export?pole=${p.id}&only_optin=true`, `beneficiaires-optin-${p.id}.csv`)}
                      data-testid={`export-pole-${p.id}`}
                      title={`Exporter les opt-in de ${p.center}`}
                      className="opacity-0 group-hover:opacity-100 transition-opacity text-slate-400 hover:text-[#E05638]"
                    >
                      <Download size={14}/>
                    </button>
                  )}
                </div>
                <div className="text-xs text-slate-500">
                  <span className="font-bold text-slate-900">{p.opt_in}</span>
                  <span className="text-slate-400"> / {p.total}</span>
                  <span className="ml-2 font-mono">{pct}%</span>
                </div>
              </div>
              <div className="mt-1.5 h-2 bg-slate-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#E05638] to-[#f0764c] transition-all"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
        {s.unknown_pole.total > 0 && (
          <div className="pt-2 border-t border-slate-100 text-xs text-slate-500 flex items-center justify-between">
            <span>Hors pôle identifié</span>
            <span className="font-mono">{s.unknown_pole.opt_in} / {s.unknown_pole.total}</span>
          </div>
        )}
      </div>
    </div>
  );
}
